export interface ReportFileExporterPlugin {
  // ANDROID
  writeReport(options: { fileNames: string[] }): Promise<{ value: any }>;
}
